<template>
  <div class="ar" v-if="charts.length || files.length">
    <AssistantChart v-for="c in charts" :key="c.id" :chart="c" />
    <AssistantFileCard v-for="f in files" :key="f.id" :file="f" />
  </div>
</template>

<script>
import AssistantChart from "./AssistantChart.vue";
import AssistantFileCard from "./AssistantFileCard.vue";

/**
 * What came with one of Connect's replies besides its words (message.rich, 2026-10-20): the charts and tables
 * of show_chart, the files of make_pdf and make_excel. Anything not shaped as expected is left out.
 */
export default {
  name: "AssistantRich",
  components: { AssistantChart, AssistantFileCard },
  props: {
    rich: { type: Object, required: true },
  },
  computed: {
    charts() { return (this.rich.charts || []).filter((c) => c && c.id && Array.isArray(c.labels) && Array.isArray(c.series) && c.table); },
    files() { return (this.rich.files || []).filter((f) => f && f.id && f.name && (f.kind === "pdf" || f.kind === "xlsx")); },
  },
};
</script>

<style scoped>
.ar { display: flex; flex-direction: column; gap: 10px; width: 100%; margin-top: 8px; }
</style>
